export default __webpack_public_path__ + "static/media/incorrect22.4252a11e.mp3";